import React, {useState, useEffect} from 'react';
import DonutChart from '../../../charts/donut'
import qrImg from '../../../../images/qr.svg'



import { Link } from 'react-router-dom';
import {depositActions} from '../../../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { userSelect, homeScreenStatSelect, allRemoteSettingsSelect, allWithdrawalSelect } from '../../../../redux/selectors/index';
import Helper1, {notify, subStr, addUrlToPath, moneyStatus, usefulColors, money} from '../../../../utility/Helper1';
import LoadingIcon from "../../../../utility/customComponents/loader/LoadingIcon";
import copy from 'copy-to-clipboard';
import { AiOutlineWallet, AiFillDelete, AiOutlineCopy, AiFillInfoCircle, AiOutlineCloudUpload } from "react-icons/ai";
import Countdown from 'react-countdown';
import WrapUpDashboard from '../../../layout/WrapUpDashboard'
import {withdrawalActions} from '../../../../redux/actions';
import QRCode from "react-qr-code";
import PinAuth from "../../../../utility/customComponents/PinAuth";
import NoData from "../../../../utility/customComponents/NoData";
import Balance from "../../Fragments/Balance";
import WalletWrapper from './WalletWrapper'




const Wallet = () => {

    const finance = useSelector(homeScreenStatSelect);
    const userData = useSelector(userSelect);
    const site_settings = useSelector(allRemoteSettingsSelect);
    const [securityObj, setSecurityObj] = useState({})
    const [currencySelected, setCurrencySelected]   = useState(finance?.[0]);
    const op_se = site_settings.operational_settings
    const loadHistoryData = useSelector(allWithdrawalSelect);


    const [amount, setAmount]   = useState('');
    const [paymentPlaceLoading, setPaymentPlaceLoading]   = useState(false);
    const [withdrawalIsActive, setWithdrawalIsActive]   = useState(false);
    const [selectedWallet, setSelectedWallet]   = useState(0);
    const [withdrawalHistoryLoading, setWithdrawalHistoryLoading]   = useState(false);

    const dispatch = useDispatch();

    const walletSources = [
                            {title: 'Main Balance', column: 'balance', id: 0, useThis: true}, 
                            {title: 'Referral Commission', column: 'commission', id: 1, useThis: Number(op_se?.useReferralBonus) === 1}, 
                            {title: 'Rebate Commission', column: 'rebateCommission', id: 2, balanceKey: 'rebateCommission', useThis: Number(op_se?.useRebateBonus) === 1},
                            {title: 'Deposit Bonus', column: 'depositBonus', id: 3, balanceKey: 'depositBonus', useThis: Number(op_se?.useDepositBonus) === 1},
                            // {title: 'Salary Wallet', column: 'salary', id: 4, balanceKey: 'salary', useThis: Number(site_settings?.salary_settings?.useSalary) === 1}
                        ]

    const processWithdrawal = (e) => {
        
        e.preventDefault();

        if(withdrawalIsActive){ return; }

        if((userData?.usdttrc20wallet?.length ?? 0) < '5'){ 
            notify('Please bind your wallet details before withdrawal.');
            return false;
        }

        if((isNaN(amount)) || (amount == 0)){
            // notify('Enter amount', 0);
            return false;
        }


        setWithdrawalIsActive(true);

        let walletChosenColumn = walletSources?.[selectedWallet]?.['column']
        
        dispatch(withdrawalActions.onCreateWithdrawal({amount: amount, ...(securityObj ?? {}), currency: currencySelected?.type, walletAddress: ''}, `withdrawal/new/${walletChosenColumn}`, response => {

            notify(response.msg, response.code)
            if(response.code == 1){
                setAmount('');
            }

            setWithdrawalIsActive(false);

        }))
    }



    const updateCurrencySelected = (typeOfSelected) => {

        let selected = finance?.filter((ite, inde) => ite.type == typeOfSelected)?.[0] ?? []
        setCurrencySelected(selected)

    }

    const changeSelectedWallet = (value) => {
        setSelectedWallet(value)
    }



    


    const styles = {
        tableResponsive: {
          height: 590, // Default height for desktop
        },
    }

    if (window.innerWidth < 768) {
        styles.tableResponsive.height = 'auto'; // Set height to auto for mobile
      }



    const loadAllWithdrawal = () => {

        setWithdrawalHistoryLoading(true)
        dispatch(withdrawalActions.onLoadAllWithdrawals("withdrawal/load", response => {

            if(response.code == 1){
                setWithdrawalHistoryLoading(false)
            }
        }))

    }

    useEffect(() => {
        loadAllWithdrawal()
    }, [])

    return (<WalletWrapper pageTitle={"Wallet"}>

        

        <div className="row">




            <div className={`col-xxl-12 col-xl-12 col-lg-12`}>
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title">Account Fund </h4>
                    </div>
                    <div className="card-body">
                        
                        <form onSubmit = {processWithdrawal} className="currency_validate trade-form row g-3">


                            <h4>{currencySelected.withdrawal_note_headline}</h4>
                            <p className="mb-0">{currencySelected.withdrawal_note_body}</p>

                            {finance?.length > 1 && <div className="col-12">
                                <label className="form-label">Wallet</label>
                                <div className="input-group">

                                    <select onChange={e => updateCurrencySelected(e.target.value)} className="form-select">
                                        {finance?.map((item, index) => <>
                                            <option value={item.type}>{item?.abbr}</option>
                                        </>)}
                                    </select>
                                    
                                </div>
                            </div>}

                            <div className="col-12">
                                <label className="form-label">Source</label>
                                <div className="input-group">


                                    <select className="form-select" value={selectedWallet} onChange={e => changeSelectedWallet(e.target.value)}>
                                        {walletSources?.map((item, index) => {
                                            
                                            let showBalance = finance?.filter(item => item?.type == currencySelected?.type)?.[0]?.[item?.balanceKey] ?? ''

                                            if(!item.useThis){ return <></>}
                                            return <option value={item?.id}>{item?.title} {showBalance != ''?` - ${money(showBalance, currencySelected?.type)}`:''}</option>
                                        })}

                                    </select>
                                    
                                </div>
                            </div>

                            <div className="col-12">
                                <label className="form-label">Enter Amount</label>
                                <div className="input-group">
                                    
                                    <input autoComplete="new-password" type="text" onChange={(e) => setAmount(e.target.value)} value={amount} name="currency_amount" className="form-control"
                                        placeholder="0.00" />

                                </div>
                            </div>

                            <PinAuth resultingObjMethod={setSecurityObj} userData={userData} />

                            <button disabled={withdrawalIsActive} type="submit" name="submit" className="btn btn-success btn-block">
                                Request
                                <LoadingIcon color={"#fff"} active={withdrawalIsActive} />
                            </button>

                        </form>

                    </div>
                </div>
            </div>

           




        </div>

    </WalletWrapper>);
};

export default Wallet;